import GlobalCapabilityCTA from "./globalCapabilityCTA/GlobalCapabilityCTA"
import GlobalCapabilityHero from "./globalCapabilityHero/GlobalCapabilityHero"
import GlobalCapabilityOverview from "./globalCapabilityOverview/GlobalCapabilityOverview"
import GlobalCapabilityServices from "./globalCapabilityServices/GlobalCapabilityServices"
import GlobalCapabilityWorkflow from "./globalCapabilityWorkflow/GlobalCapabilityWorkflow"
import WhyGlobalCapability from "./whyGlobalCapability/WhyGlobalCapability"

const GlobalCapability = () => {
  return (
    <>
    <GlobalCapabilityHero />
    <GlobalCapabilityOverview />
    <GlobalCapabilityServices />
    <WhyGlobalCapability /> 
    <GlobalCapabilityWorkflow />
    <GlobalCapabilityCTA />
    </>
  )
}

export default GlobalCapability